<template>
  <div class="outer-container">
    <div class="flex-container">
      <div class="left">
        <div>
          <p class="header">{{ $t('promotion.luckyDraw.earnedTickets') }}</p>
          <div class="ticket-text">{{ progressData.earnedTickets }}</div>
        </div>
      </div>
      <div class="right">
        <div class="right-container">
          <p class="header">{{ $t('promotion.luckyDraw.requirements') }}</p>
          <div class="inner-container">
            <div v-if="progressData.depositType || !isTrade">
              <p class="sub-header">
                {{
                  isTrade ? $t(`promotion.luckyDraw.${progressData.depositType}`) : $t(`promotion.luckyDraw.netDeposit`)
                }}
              </p>
              <h4>
                <span class="bigger-text">{{
                  progressData.totalDeposit && progressData.totalDeposit.toLocaleString('en-US')
                }}</span>
                /
                <span class="smaller-text">{{
                  progressData.minimumDeposit && progressData.minimumDeposit.toLocaleString('en-US')
                }}</span>
                <i v-if="isTrade" :class="['el-icon-success', { success: isMinDepositReached }]"></i>
              </h4>
            </div>
            <div v-if="isTrade">
              <p class="sub-header">{{ $t('promotion.luckyDraw.totalNotionalVolume') }}</p>
              <h4>
                <span class="bigger-text">{{
                  progressData.totalTrade && progressData.totalTrade.toLocaleString('en-US')
                }}</span>
                /
                <span class="smaller-text">{{
                  progressData.minimumTrade && progressData.minimumTrade.toLocaleString('en-US')
                }}</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-container">
      <!-- <img src="@/assets/images/promotion/luckyDraw/green.svg" class="img-icon_1" />
      <img src="@/assets/images/promotion/luckyDraw/orange.svg" class="img-icon_2" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progressData: {
      type: Object,
      default: () => ({})
    },
    isTrade: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isMinDepositReached() {
      return this.progressData.totalDeposit >= this.progressData.minimumDeposit;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-icon-success {
  color: grey;
  margin-left: 6px;

  &.success {
    color: #4fbc3e;
  }
}

.outer-container {
  display: flex;
  position: relative;
  background-color: #f9f9f9;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.flex-container {
  z-index: 10;
  flex: 1;
  display: flex;
  padding: 30px 20px;
  align-items: center;
  background: #f9f9f9;
  border-radius: 10px;
  .header {
    font-weight: 500;
    font-size: 14px;
    color: #232020;
    margin-bottom: 20px;
  }
  .ticket-text {
    font-weight: bold;
    font-size: 36px;
    color: #232020;
  }
  .sub-header {
    margin-bottom: 8px;
  }
  .left {
    display: flex;
    flex: 1;
    justify-content: center;
    padding-right: 20px;
  }
  .right {
    flex: 3;
    display: flex;
    justify-content: center;
    padding-left: 20px;

    @include rtl-sass-prop(border-left, border-right, 1px solid $stone-gray);

    .right-container {
      .inner-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 24px;
        column-gap: 6vw;
      }
      .bigger-text {
        font-size: 24px;
        font-weight: bold;
      }
      .smaller-text {
        font-size: 20px;
        font-weight: normal;
      }
    }
  }
}

.background-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  .img-icon_1 {
    position: absolute;
    width: 260px;
    left: -150px;
    top: -120px;
  }
  .img-icon_2 {
    position: absolute;
    opacity: 60%;
    width: 260px;
    right: -150px;
    bottom: -120px;
  }
}

@media (max-width: 1024px) {
  .outer-container {
    margin: 8px;
  }
}

@media (max-width: 550px) {
  .flex-container {
    flex-direction: column;
    align-items: flex-start;
    .left {
      width: 100%;
      justify-content: flex-start;
      border-bottom: 1px solid $stone-gray;
      padding-bottom: 16px;
      margin-bottom: 16px;
      padding-right: 0;
    }
    .right {
      flex-direction: column;
      border: 0 !important;
      padding: 0;
    }
  }
}
</style>
